module.exports = __webpack_public_path__ + "img/novydvor2_map.03244280.jpg";